import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { localizationSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';

// This function will map the current redux state to the props for the component
// that it is "connected" to.When the state of the redux store changes, this function
// will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
function mapStateToProps(state) {
  const { messages } = state.app.i18n;
  // IntlProvider accepts only the 2-char language code for the locale prop
  // (which will add support for all variants... en: en-US, zh: zh-Hans | zh-Hant, etc.)
  const language = _get(localizationSelectors.localization(state), 'language');
  return {
    locale: language,
    messages
  };
}

export default connect(mapStateToProps)(IntlProvider);
